import { useMemo } from 'react';
import moment from 'moment';
import { useTranslation } from '../../../contexts/translation';
export const useFormInputDatePickerLocalization = () => {
    const { translationByKey: t, currentLocale } = useTranslation('datePicker');
    const locale = moment.localeData();
    // Use Moment's locale aware formatting for now...
    // https://momentjs.com/docs/#/parsing/string-format/
    const format = 'L';
    const localization = useMemo(() => {
        return {
            buttonLabel: t('buttonLabel', 'Choose date'),
            placeholder: locale.longDateFormat(format),
            selectedDateMessage: t('dateIs', 'Selected date is'),
            prevMonthLabel: t('previousMonth', 'Previous month'),
            nextMonthLabel: t('nextMonth', 'Next month'),
            monthSelectLabel: t('month', 'Month'),
            yearSelectLabel: t('year', 'Year'),
            closeLabel: t('closeWindow', 'Close window'),
            calendarHeading: t('calendarHeader', 'Choose a date'),
            dayNames: locale.weekdays(),
            monthNames: locale.months(),
            monthNamesShort: locale.monthsShort(),
            locale: currentLocale,
        };
    }, [t, locale, currentLocale]);
    const firstDayOfWeek = moment.localeData().firstDayOfWeek();
    return { localization, format, firstDayOfWeek };
};
